<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<b-modal id="upload-files-modal" title="Upload file" okTitle="Upload" @show="reset" @ok.prevent="uploadFiles" :no-close-on-backdrop="blockModal" :no-close-on-esc="blockModal" :hide-header-close="blockModal" :cancel-disabled="blockModal"
  :ok-disabled="blockModal || hasErrors" size="lg">
  <b-form-file v-model="files" :multiple="true" :state="fileState" placeholder="Choose your files or drop them here..." drop-placeholder="Drop files here..." @change="selectionChanged"></b-form-file>
  <b-form-invalid-feedback id="upload-file-input-feedback" class="text-right">{{ validationError }}</b-form-invalid-feedback>
  <div class="mt-3" v-if="!blockModal && !hasErrors">Selected files: {{ selectedFiles }}</div>
  <div v-if="uploadsManager.creatingMetadata" class="mt-3">
    <b-spinner small variant="primary" label="Spinning"></b-spinner>
    Creating metadata...
  </div>
  <div v-if="uploadsManager.uploadInProgress || hasErrors" class="mt-3">
    <div v-for="(file, index) in files" :key="index" class="upload-progress-container mt-1">
      <div v-if="uploadsManager.errors[index] !== null">
        <span class="text-danger">Error for {{ file.name }}: {{ uploadsManager.errors[index] }}</span>
      </div>
      <div v-if="uploadsManager.errors[index] === null && uploadsManager.deletionStatuses[index] === null">
        {{ file.name }}<br />
        <span class="text-danger cancel-upload" @click="cancelUpload(index)" v-if="uploadsManager.progress[index] < 100">&times;</span>
        <b-progress :value="uploadsManager.progress[index]" :max="100" show-progress :animated="uploadsManager.progress[index] < 100"></b-progress>
      </div>
      <div v-if="uploadsManager.errors[index] === null && uploadsManager.deletionStatuses[index] === true">
        <b-spinner small variant="primary" label="Spinning"></b-spinner>
        Upload of {{ file.name }} has been canceled. Waiting for metadata deletion...
      </div>
      <div v-if="uploadsManager.errors[index] === null && uploadsManager.deletionStatuses[index] === false" class="text-primary">
        Upload of {{ file.name }} has been canceled.
      </div>
    </div>
  </div>
</b-modal>
</template>

<script>
const maxUploadSize = process.env.VUE_APP_MAX_UPLOAD_SIZE;

export default {
  data() {
    return {
      validationError: null
    }
  },
  computed: {
    uploadsManager() { return this.$store.state.uploadsManager },
    files: {
      get() {
        return this.uploadsManager.files;
      },
      set(files) {
        this.$store.commit('setFilesToUpload', files);
      }
    },
    fileState() {
      if (this.validationError) {
        return false;
      }
      return null;
    },
    selectedFiles() {
      if (this.files.length === 0) {
        return '';
      }
      let names = [];
      for (let file of this.files) {
        names.push(file.name);
      }
      return names.join(', ');
    },
    blockModal() {
      return this.uploadsManager.creatingMetadata || this.uploadsManager.uploadInProgress;
    },
    hasErrors() {
      return this.uploadsManager.errors.filter(e => e !== null).length > 0;
    }
  },
  methods: {
    reset() {
      this.files.splice(0, this.files.length);
      this.resetError();
    },
    resetError() {
      this.validationError = null;
      this.$store.commit('resetUploadState');
    },
    selectionChanged() {
      this.resetError();
    },
    uploadFiles() {
      if (this.blockModal) {
        return;
      }

      this.$store.commit('resetUploadState');

      if (this.files.length === 0) {
        this.validationError = "Select at least one file";
      } else {
        // Check special characters in file names
        for (let file of this.files) {
          if (/[<>?":\\/`|'*]/.test(file.name)) {
            this.validationError = "File " + file.name + " contains an illegal character. Following characters are not allowed: < > ? \" : \\ / | ' * `";
            return;
          }
        }

        // Check size limit
        for (let file of this.files) {
          if (file.size >= maxUploadSize * Math.pow(10, 9)) {
            this.validationError = "File " + file.name + " is too big. Max allowed file size is " + maxUploadSize + " GB";
            return;
          }
        }

        // $bvModal instance is passed to the upload manager because modal has
        // to be closed at the end of a successful upload
        this.$store.dispatch('upload', this.$bvModal);
      }
    },
    cancelUpload(index) {
      this.$store.dispatch('cancelUpload', index);
    }
  }
}
</script>

<style>
.upload-progress-container {
  position: relative;
}

.cancel-upload {
  cursor: pointer;
  position: absolute;
  right: 3px;
  top: 12px;
  font-size: 170%;
}
</style>
